"use strict";

/* Liste de variable */
var timeleft = 21;
var score = 0;
var downloadTimer;
var tab_datatruth;
var tab_image;
var btn_begin = document.querySelector(".game__button");
var endgame = 0;
var popup = document.querySelector(".popup");

const validationElement = document.querySelectorAll(".game__carte");
const counter = document.querySelector("#counter");
const selectionLi = document.querySelectorAll(".game__carte1--list li");
const selectionLi2 = document.querySelectorAll(".game__carte2--list li");
const selectionClass = document.querySelectorAll(".game__carte1--el");
const selectionClass2 = document.querySelectorAll(".game__carte2--el");
const icon = document.querySelectorAll(".game__carte--icon img");
var scorefinal = document.querySelector(".scorefinal__li");
var btn_scorefinal = document.querySelector("#scorefinal-close");


/* Liste des fonctions */

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min +1)) + min;
}

/* Tableau */
var tab_true = [];
var tab_false = [];

var tab_shuffle = [];

var tab_info = [];


/* Récuperation du Json */
fetch("./assets/json/json.json")
  .then(
    (response) => {
      response.json().then((text) => {
       console.log(text);
/* Remplissage des tableaux */
      for (let i=0; i<text.Death.length; i++){
        if (text.Death[i].truth === "true"){
          tab_true.push(text.Death[i]);
        } else {
          tab_false.push(text.Death[i]);
        }
      }

      /* Shuffle */
      function shuffleArray(inputArray){
        inputArray.sort(()=> Math.random() - 0.5);
      }   
      shuffleArray(tab_true);
      shuffleArray(tab_false);

      /* Button Start*/
      btn_begin.addEventListener("click", (e)=>{

        btn_begin.innerHTML = "Next"

        console.table(tab_true);
        console.table(tab_false);
  
        
        for (let validation of validationElement){
          validation.classList.remove("bad-answer");
        }

        for (let validation of validationElement  ){
          validation.classList.remove("good-answer");
        }
        
        var truedeath = tab_true.pop();
        var falsedeath = tab_false.pop();

        tab_shuffle = [];
        timeleft = 20;

        endgame = endgame + 1;
        console.log(endgame);



        for (let collection of selectionLi){
          collection.classList.add("hide");
        }

        for (let collection of selectionLi2){
          collection.classList.add("hide");
        }

        tab_shuffle.push(truedeath, falsedeath);
        shuffleArray(tab_shuffle);
        console.table(tab_shuffle);

        var tab_info_0 = [tab_shuffle[0].name,tab_shuffle[0].number,tab_shuffle[0].date,tab_shuffle[0].country,tab_shuffle[0].info];
        var tab_info_1 = [tab_shuffle[1].name,tab_shuffle[1].number,tab_shuffle[1].date,tab_shuffle[1].country,tab_shuffle[1].info];

        for (let i=0; i<tab_shuffle.length; i++){

          tab_datatruth = tab_shuffle[i].truth;

          tab_image = tab_shuffle[i].img;

          validationElement[i].setAttribute("data-truth",tab_datatruth);

          icon[i].setAttribute("src", tab_image); 
        }

        for (let i=0; i<selectionClass.length; i++){
          selectionClass[i].innerHTML = tab_info_0[i];
        }

        for (let i=0; i<selectionClass2.length; i++){
          selectionClass2[i].innerHTML = tab_info_1[i];
        }

        console.table(tab_datatruth);
        console.table(tab_info);


        /* Timer */
         downloadTimer = setInterval(function(){
          if(timeleft <= 0){

            clearInterval(downloadTimer);
            clearInterval(0);
            document.getElementById("countdown").innerHTML = "0";

          } else if(timeleft === 20){

            let img = document.querySelectorAll(".game__carte--icon");
            for(let i = 0; i < img.length; i++){
            img[i].classList.toggle("hide");}

          } else if(timeleft === 17){

            let name = document.querySelectorAll(".game__type");
            for(let i = 0; i < name.length; i++){ 
            name[i].classList.toggle("hide");}

          } else if(timeleft === 14){

            let number = document.querySelectorAll(".game__death");
            for(let i = 0; i < number.length; i++){ 
            number[i].classList.toggle("hide");}

            let date = document.querySelectorAll(".game__date");
            for(let i = 0; i < date.length; i++){ 
            date[i].classList.toggle("hide");}

            let country = document.querySelectorAll(".game__country");
            for(let i = 0; i < country.length; i++){ 
            country[i].classList.toggle("hide");}

          } else if(timeleft === 12){

            let info = document.querySelectorAll(".game__description");
            for(let i = 0; i < info.length; i++){ 
            info[i].classList.toggle("hide");}
          }
        
            btn_begin.classList.add("hide");

          document.getElementById("countdown").innerHTML = timeleft;
          timeleft--;
        }, 1000);

      })




      /* Récuperer la valeur du timer */
      for (let validation of validationElement){
        validation.addEventListener("click",(e)=>{
        clearInterval(downloadTimer);
          var truth = e.currentTarget.getAttribute("data-truth");
          console.log(truth);

          /* Ajout de la classe mauvaise réponse */
          if (truth === "false"){
            score = score - timeleft;
            e.currentTarget.classList.add("bad-answer");

          /* Ajout de la classe mauvaise réponse */
          } else if (truth === "true"){
            score = score + timeleft;
            e.currentTarget.classList.add("good-answer");
          }

          counter.innerHTML = score;
          document.getElementById("countdown").innerHTML = "0";
          timeleft = 0;

          for (let collection of selectionLi){
            collection.classList.remove("hide");
          }

          for (let collection of selectionLi2){
            collection.classList.remove("hide");
          }

          btn_begin.classList.remove("hide");

          if (endgame === 6){
            btn_begin.innerHTML = "Try Again"

            scorefinal.innerHTML = "Score final : " + score;
            
            document.querySelector(".scorefinal").classList.add("addblock")

            window.addEventListener("click", function(){
              setTimeout(
                  function open(event){
                  },
                500
              )
            });
            
            document.querySelector("#scorefinal-close").addEventListener("click", function(){
              document.querySelector(".scorefinal").classList.remove("addblock")
            });
            

            btn_begin.addEventListener("click", function(){
              location.reload()
            });
          };
        });
      }
    })
  },
  /* Affiche une erreur console si le JSON ne se charge pas bien */
  (response) => {
    console.error("Erreur");
  }
);


/* Timeline */
(function () {
  var items = document.querySelectorAll(".timeline li");
  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function callbackFunc() {
    for (var i = 0; i < items.length; i++) {
      if (isElementInViewport(items[i])) {
        items[i].classList.add("in-view");
      }
    }
  }
  window.addEventListener("load", callbackFunc);
  window.addEventListener("resize", callbackFunc);
  window.addEventListener("scroll", callbackFunc);
})();

/* Pop Up */
window.addEventListener("load", function(){
  setTimeout(
      function open(event){
      },
    500
  )
});

document.querySelector("#close").addEventListener("click", function(){
  document.querySelector(".popup").classList.add("removeblock")
});


//Copyright
let date = new Date();
let year = date.getFullYear();

let yr = document.querySelector(".copyright");
yr.innerText = year;


/* Merci à Julien pour l'aide sur les pépins <3 */